











import Vue, { PropType } from 'vue';
import {
  options,
} from 'mostra';

export default Vue.extend({
  name: 'GSelectedTemplateNotation',
  props: {
    templateId: {
      type: Number as PropType<number>,
      default: null,
    },
    isShowReset: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    onClickReset: { type: Function as PropType<() => void> },
  },
  computed: {
    tempateName() {
      const selectedTemplateId = this.templateId;
      const selectedTemplate = options.templateOptions.find(
        (template: any) => selectedTemplateId === template.value,
      );
      if (!selectedTemplate) return '';
      return selectedTemplate.text;
    },
  },
});
